<template>
  <div class="about-us-founders">
    <p class="about-us-founders__title">
      Ostado’s Founders
    </p>
    <div class="about-us-founders__items">
      <div v-for="item in founders" class="founders-item">
        <div class="mt-[-10px] lg:mt-[-60px]">
          <img
            :data-src="item.picture"
            width="444"
            height="444"
            class="lazyload mx-auto rounded-2xl w-[216px] lg:w-[270px]"
            :alt="item.name"
          >
        </div>
        <div class="founders-item__captions">
          <div>
            <p class="founders-item__name">
              {{ item.name }}
            </p>
            <p class="founders-item__position">
              {{ item.job_position }}
            </p>
          </div>
          <div>
            <a :href="item.linkedin" target="_blank">
              <BaseIcon
                name="linkedin"
                type="custom"
                scale="2"
                color="text-primary-600"
                custom-size="w-8 h-8 lg:w-10 lg:h-10"
                view-box="0 0 40 40"
              />
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import staticData from './static-data'
export default {
  name: 'AboutUsFounders',
  data () {
    return {
      ...staticData
    }
  }
}
</script>

<style scoped lang="scss">
.about-us-founders {
  @apply container;
  &__title {
    @apply text__headline-3-xs--bold lg:text__headline-3-md--bold text-center mb-8;
  }
  &__items {
    @apply flex flex-col lg:flex-row justify-between lg:space-x-6 lg:mt-[108px] mt-16 space-y-[68px] lg:space-y-0;
    .founders-item {
      @apply bg-primary-100 w-full pb-8 lg:pb-6 rounded-2xl px-6 lg:px-0;
      &__captions {
        @apply flex items-end justify-between max-w-[444px] mx-auto mt-3 lg:mt-6 mb-8 lg:mb-0;
      }
      &__name {
        @apply text__headline-3-xs--semibold lg:text__headline-4-md--semibold;
      }
      &__position {
        @apply text__headline-3-xs--semibold lg:text__headline-4-md--bold text-primary-600 mt-3 lg:mt-6;
      }
    }
  }
}
</style>
